<div class="modal-header">
    <h5 class="modal-title" id="editCompanyTitle">Edit Company</h5>
    <button type="button" (click)="dismiss()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
    <form [formGroup]="manageCompanyInfoForm">
        <div class="row">
            <div class="col-md-5 mb-3">
                <label for="numberOfEmployees" class="form-label"># of Employees in 10 County Region</label>
                <select formControlName="numberOfEmployees" class="form-select" aria-label="numberOfEmployees"
                    id="numberOfEmployees">
                    <option *ngFor="let emp of numberOfEmployeesOptions" value="{{emp.value}}">{{emp.text}}</option>
                </select>
                <div *ngIf="numberOfEmployeesCtrl.invalid && (numberOfEmployeesCtrl.dirty || numberOfEmployeesCtrl.touched)"
                    class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label for="businessPhone" class="form-label">Business Phone</label>
                <input formControlName="phoneNumber" mask="(000) 000-0000" type="text" class="form-control"
                    id="businessPhone" placeholder="(123) 123-1234">
                <div *ngIf="phoneNumberCtrl.invalid && (phoneNumberCtrl.dirty || phoneNumberCtrl.touched)"
                    class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <div class="form-check">

                    <input [value]="true" [formControl]="isPrivateAddressCtrl" [checked]="true" class="form-check-input"
                        type="checkbox" id="privateAddress">
                    <label for="businessPhone" class="form-label">Private Address?</label>

                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label for="website" class="form-label">Industry</label>
                <select formControlName="industry" class="form-select" aria-label="industry" id="industry">
                    <option selected value="-1">Select an Industry</option>
                    <option *ngFor="let ind of industryOptions" value="{{ind}}">{{ind}}</option>
                </select>
                <div *ngIf="industryCtrl.invalid && (industryCtrl.dirty || industryCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="col-12 mb-3">
                <label for="selfIdentifyList" class="form-label">Business Self-Identifies As:</label>

                <div class="form-check">
                    <input formControlName="isAlaskanNative" class="form-check-input" type="checkbox"
                        id="selfIdentify1">
                    <label class="form-check-label" for="selfIdentify">
                        Alaskan Native American Indian-Owned
                    </label>
                </div>
                <div class="form-check">
                    <input formControlName="isAsian" class="form-check-input" type="checkbox" id="selfIdentify2">
                    <label class="form-check-label" for="selfIdentify">
                        Asian-Owned
                    </label>
                </div>
                <div class="form-check">
                    <input formControlName="isBlack" class="form-check-input" type="checkbox" id="selfIdentify3">
                    <label class="form-check-label" for="selfIdentify">
                        Black-Owned
                    </label>
                </div>
                <div class="form-check">
                    <input formControlName="isDisability" class="form-check-input" type="checkbox" id="selfIdentify4">
                    <label class="form-check-label" for="selfIdentify">
                        Disability-Owned
                    </label>
                </div>
                <div class="form-check">
                    <input formControlName="isHispanic" class="form-check-input" type="checkbox" id="selfIdentify5">
                    <label class="form-check-label" for="selfIdentify">
                        Hispanic-Owned
                    </label>
                </div>
                <div class="form-check">
                    <input formControlName="isLGBTQ" class="form-check-input" type="checkbox" id="selfIdentify6">
                    <label class="form-check-label" for="selfIdentify">
                        LGBTQ+-Owned
                    </label>
                </div>
                <div class="form-check">
                    <input formControlName="isVeteran" class="form-check-input" type="checkbox" id="selfIdentify7">
                    <label class="form-check-label" for="selfIdentify">
                        Veteran-Owned
                    </label>
                </div>
                <div class="form-check">
                    <input formControlName="isWomen" class="form-check-input" type="checkbox" id="selfIdentify8">
                    <label class="form-check-label" for="selfIdentify">
                        Women-Owned
                    </label>
                </div>
                <div class="form-check">
                    <input formControlName="isOtherMinority" class="form-check-input" type="checkbox"
                        id="selfIdentify9">
                    <label class="form-check-label" for="selfIdentify">
                        Other Minority-Owned
                    </label>
                </div>
                <div class="form-check">
                    <input formControlName="noneOfTheAbove" class="form-check-input" type="checkbox"
                        id="selfIdentify10">
                    <label class="form-check-label" for="selfIdentify">
                        None of the above
                    </label>
                </div>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-12 mb-3">
            <label for="certSelect" class="form-label">Minority Owned Certification(s)</label>
            <input mbsc-select (onChange)="changedMSelect($event)" class="form-select" [(ngModel)]="selectedCerts"
                multiple [data]="minorityCertificateTypes" [selectMultiple]="true">
        </div>
    </div>

</div>
<div class="modal-footer">
    <button type="button" (click)="save()" class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
    <button type="button" (click)="dismiss()" class="btn btn-cancel text-strong text-uppercase m-100"
        data-bs-dismiss="modal">Cancel</button>
</div>